import React, { useState, useCallback } from 'react';
import delhiIcon from '../Assets/delhi.svg';
import mumbaiIcon from '../Assets/mumbai.svg';
import chandigarhIcon from '../Assets/chandigarh.svg';
import hyderabadIcon from '../Assets/hyderabad.svg';
import ahmedabadIcon from '../Assets/ahemdabad.svg';
import kolkataIcon from '../Assets/kolkata.svg';
import chennaiIcon from '../Assets/chennai.svg';
import bengaluruIcon from '../Assets/bengaluru.svg';
import puneIcon from '../Assets/pune.svg';

// Complete Indian cities database with coordinates
const allIndianCities = [
  { name: "Agra", coordinates: { latitude: 27.1767, longitude: 78.0081 }, aliases: ['Agra'] },
  { name: "Ahmedabad", coordinates: { latitude: 23.0225, longitude: 72.5714 }, aliases: ['Ahmedabad', 'Amdavad'] },
  { name: "Allahabad", coordinates: { latitude: 25.4358, longitude: 81.8463 }, aliases: ['Allahabad', 'Prayagraj'] },
  { name: "Amritsar", coordinates: { latitude: 31.6340, longitude: 74.8723 }, aliases: ['Amritsar'] },
  { name: "Aurangabad", coordinates: { latitude: 19.8762, longitude: 75.3433 }, aliases: ['Aurangabad'] },
  { name: "Bengaluru", coordinates: { latitude: 12.9716, longitude: 77.5946 }, aliases: ['Bengaluru', 'Bangalore'] },
  { name: "Bareilly", coordinates: { latitude: 28.3670, longitude: 79.4304 }, aliases: ['Bareilly'] },
  { name: "Bhopal", coordinates: { latitude: 23.2599, longitude: 77.4126 }, aliases: ['Bhopal'] },
  { name: "Bhubaneswar", coordinates: { latitude: 20.2961, longitude: 85.8245 }, aliases: ['Bhubaneswar'] },
  { name: "Chandigarh", coordinates: { latitude: 30.7333, longitude: 76.5794 }, aliases: ['Chandigarh', 'Mohali', 'Panchkula'] },
  { name: "Chennai", coordinates: { latitude: 13.0827, longitude: 80.2707 }, aliases: ['Chennai', 'Madras'] },
  { name: "Coimbatore", coordinates: { latitude: 11.0168, longitude: 76.9558 }, aliases: ['Coimbatore'] },
  { name: "Cuttack", coordinates: { latitude: 20.4625, longitude: 85.8828 }, aliases: ['Cuttack'] },
  { name: "Dehradun", coordinates: { latitude: 30.3165, longitude: 78.0322 }, aliases: ['Dehradun'] },
  { name: "Delhi", coordinates: { latitude: 28.7041, longitude: 77.1025 }, aliases: ['Delhi', 'New Delhi'] },
  { name: "Delhi/NCR", coordinates: { latitude: 28.7041, longitude: 77.1025 }, aliases: ['Delhi/NCR', 'NCR', 'Gurgaon', 'Noida', 'Faridabad', 'Ghaziabad'] },
  { name: "Dhanbad", coordinates: { latitude: 23.7957, longitude: 86.4304 }, aliases: ['Dhanbad'] },
  { name: "Durgapur", coordinates: { latitude: 23.5204, longitude: 87.3119 }, aliases: ['Durgapur'] },
  { name: "Faridabad", coordinates: { latitude: 28.4089, longitude: 77.3178 }, aliases: ['Faridabad'] },
  { name: "Ghaziabad", coordinates: { latitude: 28.6692, longitude: 77.4538 }, aliases: ['Ghaziabad'] },
  { name: "Gorakhpur", coordinates: { latitude: 26.7606, longitude: 83.3732 }, aliases: ['Gorakhpur'] },
  { name: "Gurgaon", coordinates: { latitude: 28.4595, longitude: 77.0266 }, aliases: ['Gurgaon', 'Gurugram'] },
  { name: "Guwahati", coordinates: { latitude: 26.1445, longitude: 91.7362 }, aliases: ['Guwahati'] },
  { name: "Gwalior", coordinates: { latitude: 26.2183, longitude: 78.1828 }, aliases: ['Gwalior'] },
  { name: "Hubli", coordinates: { latitude: 15.3647, longitude: 75.1240 }, aliases: ['Hubli'] },
  { name: "Hyderabad", coordinates: { latitude: 17.3850, longitude: 78.4867 }, aliases: ['Hyderabad', 'Secunderabad', 'Cyberabad'] },
  { name: "Indore", coordinates: { latitude: 22.7196, longitude: 75.8577 }, aliases: ['Indore'] },
  { name: "Jaipur", coordinates: { latitude: 26.9124, longitude: 75.7873 }, aliases: ['Jaipur', 'Pink City'] },
  { name: "Jalandhar", coordinates: { latitude: 31.3260, longitude: 75.5762 }, aliases: ['Jalandhar'] },
  { name: "Jammu", coordinates: { latitude: 32.7266, longitude: 74.8570 }, aliases: ['Jammu'] },
  { name: "Jamshedpur", coordinates: { latitude: 22.8046, longitude: 86.2029 }, aliases: ['Jamshedpur'] },
  { name: "Jodhpur", coordinates: { latitude: 26.2389, longitude: 73.0243 }, aliases: ['Jodhpur'] },
  { name: "Kanpur", coordinates: { latitude: 26.4499, longitude: 80.3319 }, aliases: ['Kanpur'] },
  { name: "Kochi", coordinates: { latitude: 9.9312, longitude: 76.2673 }, aliases: ['Kochi', 'Cochin'] },
  { name: "Kolkata", coordinates: { latitude: 22.5726, longitude: 88.3639 }, aliases: ['Kolkata', 'Calcutta', 'Howrah'] },
  { name: "Kota", coordinates: { latitude: 25.2138, longitude: 75.8648 }, aliases: ['Kota'] },
  { name: "Kozhikode", coordinates: { latitude: 11.2588, longitude: 75.7804 }, aliases: ['Kozhikode', 'Calicut'] },
  { name: "Lucknow", coordinates: { latitude: 26.8467, longitude: 80.9462 }, aliases: ['Lucknow'] },
  { name: "Ludhiana", coordinates: { latitude: 30.9010, longitude: 75.8573 }, aliases: ['Ludhiana'] },
  { name: "Madurai", coordinates: { latitude: 9.9252, longitude: 78.1198 }, aliases: ['Madurai'] },
  { name: "Mangalore", coordinates: { latitude: 12.9141, longitude: 74.8560 }, aliases: ['Mangalore'] },
  { name: "Meerut", coordinates: { latitude: 28.9845, longitude: 77.7064 }, aliases: ['Meerut'] },
  { name: "Mumbai", coordinates: { latitude: 19.0760, longitude: 72.8777 }, aliases: ['Mumbai', 'Bombay', 'Navi Mumbai', 'Thane'] },
  { name: "Mysore", coordinates: { latitude: 12.2958, longitude: 76.6394 }, aliases: ['Mysore'] },
  { name: "Nagpur", coordinates: { latitude: 21.1458, longitude: 79.0882 }, aliases: ['Nagpur'] },
  { name: "Nashik", coordinates: { latitude: 19.9975, longitude: 73.7898 }, aliases: ['Nashik'] },
  { name: "Noida", coordinates: { latitude: 28.5355, longitude: 77.3910 }, aliases: ['Noida'] },
  { name: "Patna", coordinates: { latitude: 25.5941, longitude: 85.1376 }, aliases: ['Patna'] },
  { name: "Pondicherry", coordinates: { latitude: 11.9416, longitude: 79.8083 }, aliases: ['Pondicherry', 'Puducherry'] },
  { name: "Pune", coordinates: { latitude: 18.5204, longitude: 73.8567 }, aliases: ['Pune', 'Pimpri-Chinchwad'] },
  { name: "Raipur", coordinates: { latitude: 21.2514, longitude: 81.6296 }, aliases: ['Raipur'] },
  { name: "Rajkot", coordinates: { latitude: 22.3039, longitude: 70.8022 }, aliases: ['Rajkot'] },
  { name: "Ranchi", coordinates: { latitude: 23.3441, longitude: 85.3096 }, aliases: ['Ranchi'] },
  { name: "Rourkela", coordinates: { latitude: 22.2604, longitude: 84.8536 }, aliases: ['Rourkela'] },
  { name: "Salem", coordinates: { latitude: 11.6643, longitude: 78.1460 }, aliases: ['Salem'] },
  { name: "Siliguri", coordinates: { latitude: 26.7271, longitude: 88.3953 }, aliases: ['Siliguri'] },
  { name: "Srinagar", coordinates: { latitude: 34.0837, longitude: 74.7973 }, aliases: ['Srinagar'] },
  { name: "Surat", coordinates: { latitude: 21.1702, longitude: 72.8311 }, aliases: ['Surat'] },
  { name: "Thane", coordinates: { latitude: 19.2183, longitude: 72.9781 }, aliases: ['Thane'] },
  { name: "Thiruvananthapuram", coordinates: { latitude: 8.5241, longitude: 76.9366 }, aliases: ['Thiruvananthapuram', 'Trivandrum'] },
  { name: "Thrissur", coordinates: { latitude: 10.5276, longitude: 76.2144 }, aliases: ['Thrissur'] },
  { name: "Tiruchirappalli", coordinates: { latitude: 10.7905, longitude: 78.7047 }, aliases: ['Tiruchirappalli', 'Trichy'] },
  { name: "Tirunelveli", coordinates: { latitude: 8.7139, longitude: 77.7567 }, aliases: ['Tirunelveli'] },
  { name: "Tirupati", coordinates: { latitude: 13.6288, longitude: 79.4192 }, aliases: ['Tirupati'] },
  { name: "Udaipur", coordinates: { latitude: 24.5854, longitude: 73.7125 }, aliases: ['Udaipur'] },
  { name: "Ujjain", coordinates: { latitude: 23.1765, longitude: 75.7885 }, aliases: ['Ujjain'] },
  { name: "Vadodara", coordinates: { latitude: 22.3072, longitude: 73.1812 }, aliases: ['Vadodara', 'Baroda'] },
  { name: "Varanasi", coordinates: { latitude: 25.3176, longitude: 82.9739 }, aliases: ['Varanasi', 'Banaras'] },
  { name: "Vellore", coordinates: { latitude: 12.9165, longitude: 79.1325 }, aliases: ['Vellore'] },
  { name: "Vijayawada", coordinates: { latitude: 16.5062, longitude: 80.6480 }, aliases: ['Vijayawada'] },
  { name: "Visakhapatnam", coordinates: { latitude: 17.6868, longitude: 83.2185 }, aliases: ['Visakhapatnam', 'Vizag'] },
  { name: "Warangal", coordinates: { latitude: 17.9689, longitude: 79.5941 }, aliases: ['Warangal'] }
];

// Extract popular cities from the main database
const popularCityNames = ['Delhi/NCR', 'Mumbai', 'Chandigarh', 'Hyderabad', 'Ahmedabad', 'Kolkata', 'Chennai', 'Bengaluru', 'Pune'];
const popularCities = popularCityNames.map(name => {
  const cityData = allIndianCities.find(city => city.name === name);
  const iconMap = {
    'Delhi/NCR': delhiIcon,
    'Mumbai': mumbaiIcon,
    'Chandigarh': chandigarhIcon,
    'Hyderabad': hyderabadIcon,
    'Ahmedabad': ahmedabadIcon,
    'Kolkata': kolkataIcon,
    'Chennai': chennaiIcon,
    'Bengaluru': bengaluruIcon,
    'Pune': puneIcon
  };
  return {
    ...cityData,
    icon: iconMap[name]
  };
});

// More cities are all cities except the popular ones
const moreCities = allIndianCities.filter(city => !popularCityNames.includes(city.name));

const CitySelectionModal = ({ isOpen, onClose, onCitySelect }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [locationError, setLocationError] = useState('');
  const [currentSelectedCity, setCurrentSelectedCity] = useState(() => {
    const storedCityData = localStorage.getItem("selectedCityData");
    if (storedCityData) {
      try {
        const parsed = JSON.parse(storedCityData);
        return parsed.name || "";
      } catch (e) {
        // Fallback for old format
        return localStorage.getItem("selectedCity") || "";
      }
    }
    return "";
  });

  // Fuzzy search function
  const fuzzySearch = (query, text) => {
    const queryLower = query.toLowerCase().trim();
    const textLower = text.toLowerCase();
    
    if (textLower.includes(queryLower)) return true;
    
    // Check for character matches with some flexibility
    let queryIndex = 0;
    for (let i = 0; i < textLower.length && queryIndex < queryLower.length; i++) {
      if (textLower[i] === queryLower[queryIndex]) {
        queryIndex++;
      }
    }
    return queryIndex === queryLower.length;
  };

  // Enhanced search that includes both popular and more cities
  const getFilteredCities = () => {
    if (!searchTerm.trim()) return { popular: popularCities, more: [] };

    const filteredPopular = popularCities.filter(city => 
      fuzzySearch(searchTerm, city.name) ||
      city.aliases.some(alias => fuzzySearch(searchTerm, alias))
    );

    const filteredMore = moreCities.filter(city =>
      fuzzySearch(searchTerm, city.name) ||
      city.aliases.some(alias => fuzzySearch(searchTerm, alias))
    );

    return { popular: filteredPopular, more: filteredMore };
  };

  const { popular: filteredPopularCities, more: filteredMoreCities } = getFilteredCities();

  // Helper function to find city data with coordinates
  const findCityData = (cityName) => {
    return allIndianCities.find(city => 
      city.name === cityName || 
      city.aliases.some(alias => alias.toLowerCase() === cityName.toLowerCase())
    );
  };

  const handleCityClick = (cityName) => {
    const cityData = findCityData(cityName);
    
    if (cityData) {
      // Store both name and coordinates
      const cityInfo = {
        name: cityData.name,
        coordinates: cityData.coordinates
      };
      
      localStorage.setItem("selectedCityData", JSON.stringify(cityInfo));
      // Keep old format for backward compatibility
      localStorage.setItem("selectedCity", cityData.name);
      setCurrentSelectedCity(cityData.name);
      onCitySelect(cityData.name);
    } else {
      // Fallback for cities not in database
      localStorage.setItem("selectedCity", cityName);
      setCurrentSelectedCity(cityName);
      onCitySelect(cityName);
    }
    
    onClose();
    setLocationError('');
  };

  // Enhanced geolocation with better error handling and city matching
  const getUserLocation = useCallback(async () => {
    setIsLoading(true);
    setLocationError('');

    if (!navigator.geolocation) {
      setLocationError("Geolocation is not supported by this browser");
      setIsLoading(false);
      return;
    }

    const timeoutId = setTimeout(() => {
      setIsLoading(false);
      setLocationError("Location request timed out. Please try again or select manually.");
    }, 10000); // 10 second timeout

    const options = {
      enableHighAccuracy: true,
      timeout: 10000,
      maximumAge: 300000 // 5 minutes
    };

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        clearTimeout(timeoutId);
        try {
          const { latitude, longitude } = position.coords;

          const response = await fetch(
            `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json&zoom=10`
          );

          if (!response.ok) {
            throw new Error('Failed to fetch location data');
          }

          const data = await response.json();
          
          // Better city name extraction
          const possibleCityNames = [
            data.address?.city,
            data.address?.town,
            data.address?.municipality,
            data.address?.state_district,
            data.address?.county,
            data.address?.state
          ].filter(Boolean);

          let detectedCity = null;
          let matchedCityName = null;

                     // Try to match with all cities
           for (const cityName of possibleCityNames) {
             const matchedCity = allIndianCities.find(city => 
               city.aliases.some(alias => 
                 alias.toLowerCase().includes(cityName.toLowerCase()) ||
                 cityName.toLowerCase().includes(alias.toLowerCase())
               )
             );
             
             if (matchedCity) {
               detectedCity = matchedCity.name;
               matchedCityName = cityName;
               break;
             }
           }

          if (detectedCity) {
            // Show success message and auto-select
            setLocationError(`📍 Detected: ${matchedCityName}. Selecting ${detectedCity}...`);
            setTimeout(() => {
              handleCityClick(detectedCity);
            }, 1500);
          } else {
            setLocationError(`📍 Detected: ${possibleCityNames[0] || 'Unknown location'}. Please select your city manually.`);
          }

        } catch (error) {
          console.error("Error fetching location:", error);
          setLocationError("Failed to get location details. Please select manually.");
        } finally {
          setIsLoading(false);
        }
      },
      (error) => {
        clearTimeout(timeoutId);
        setIsLoading(false);
        
        switch (error.code) {
          case error.PERMISSION_DENIED:
            setLocationError("Location access denied. Please enable location permissions and try again.");
            break;
          case error.POSITION_UNAVAILABLE:
            setLocationError("Location information unavailable. Please select manually.");
            break;
          case error.TIMEOUT:
            setLocationError("Location request timed out. Please try again or select manually.");
            break;
          default:
            setLocationError("An unknown error occurred. Please select manually.");
            break;
        }
      },
      options
    );
  }, []);

  if (!isOpen) return null;

  return (
    <div 
      className="fixed z-[1000] bg-black bg-opacity-80"
      style={{ 
        top: 0, 
        left: 0, 
        width: '100vw', 
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: 0,
        padding: '20px',
        boxSizing: 'border-box'
      }}
    >
      <div 
        className="bg-[#111111] rounded-3xl p-6 relative text-white flex flex-col overflow-hidden shadow-2xl"
        style={{
          width: '100%',
          maxWidth: '640px',
          height: '500px'
        }}
      >
        <button 
          className="absolute top-4 right-4 text-white text-2xl hover:text-gray-300 transition-colors z-10" 
          onClick={onClose}
          aria-label="Close modal"
        >
          ×
        </button>

        <h2 className="text-xl font-semibold mb-4">Select Your City</h2>

        {/* Search Bar */}
        <div className="mb-4 flex items-center bg-[#2A2A2A] px-4 py-3 rounded-lg">
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Search for your city..."
            className="bg-transparent text-white outline-none flex-1 placeholder-gray-400"
          />
          <button
            onClick={getUserLocation}
            disabled={isLoading}
            title="Detect current location"
            className={`ml-3 px-3 py-1 rounded transition-all ${
              isLoading 
                ? 'text-gray-400 cursor-not-allowed' 
                : 'text-blue-400 hover:text-blue-300 hover:bg-blue-400/10'
            }`}
          >
            {isLoading ? (
              <div className="animate-spin h-5 w-5 border-2 border-blue-400 border-t-transparent rounded-full"></div>
            ) : (
              '📍'
            )}
          </button>
        </div>

        {/* Location Status/Error Message */}
        {locationError && (
          <div className={`mb-4 p-3 rounded-lg text-sm ${
            locationError.includes('Detected:') 
              ? 'bg-[#17BD3B]/20 text-[#17BD3B] border border-[#17BD3B]/30' 
              : 'bg-red-600/20 text-red-300 border border-red-600/30'
          }`}>
            {locationError}
          </div>
        )}

        {/* Scrollable Content Area */}
        <div className="flex-1 overflow-y-auto">
          {/* Popular Cities */}
          {filteredPopularCities.length > 0 && (
            <div className="mb-4">
              <h3 className="text-lg font-medium mb-3">
                {searchTerm ? 'Matching Popular Cities' : 'Popular Cities'}
              </h3>
              <div className="grid grid-cols-5 gap-3">
                {filteredPopularCities.map((city, index) => {
                  const isSelected = currentSelectedCity === city.name;
                  return (
                    <div
                      key={index}
                      className="bg-[#2A2A2A] rounded-lg p-3 flex flex-col items-center justify-center hover:bg-[#3A3A3A] cursor-pointer transition-all hover:scale-105"
                      onClick={() => handleCityClick(city.name)}
                    >
                      <img 
                        src={city.icon} 
                        alt={city.name} 
                        className="h-8 w-8 mb-2"
                        style={isSelected ? { filter: 'brightness(0) saturate(100%) invert(46%) sepia(85%) saturate(2007%) hue-rotate(101deg) brightness(102%) contrast(98%)' } : {}}
                      />
                      <p className={`text-sm text-center`} style={isSelected ? { color: '#17BD3B' } : {}}>{city.name}</p>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {/* More Cities */}
          {(filteredMoreCities.length > 0 || (!searchTerm && moreCities.length > 0)) && (
            <div className="mb-4">
              <h3 className="text-lg font-medium mb-3">
                {searchTerm ? 'More Matching Cities' : 'More Cities'}
              </h3>
              <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 text-sm">
                {(searchTerm ? filteredMoreCities : moreCities).map((city, i) => {
                  const isSelected = currentSelectedCity === city.name;
                  return (
                    <button
                      key={i}
                      className={`text-left p-2 rounded transition-colors hover:bg-[#2A2A2A] ${
                        isSelected
                          ? ''
                          : 'text-gray-300 hover:text-white'
                      }`}
                      style={isSelected ? { color: '#17BD3B' } : {}}
                      onClick={() => handleCityClick(city.name)}
                    >
                      {city.name}
                    </button>
                  );
                })}
              </div>
            </div>
          )}

          {/* No Results */}
          {searchTerm && filteredPopularCities.length === 0 && filteredMoreCities.length === 0 && (
            <div className="text-center text-gray-400 py-8">
              <p>No cities found matching "{searchTerm}"</p>
              <p className="text-sm mt-2">Try a different search term or use location detection</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CitySelectionModal;
